/**
 * @description Сохранить фильтры "Касса" (CashboxManual.vue)
 * @type {string}
 */
export const STORE_CASHBOX_FILTERS = 'STORE_CASHBOX_FILTERS';
/**
 * @description Очистить фильтры "Касса" (CashboxManual.vue)
 * @type {string}
 */
export const CLEAR_CASHBOX_FILTERS = 'CLEAR_CASHBOX_FILTERS';
